import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {YzPageComponent} from './yz-page/yz-page.component';
import {SharedModule} from "../shared.module";
import {YzBottomBtnComponent} from './yz-bottom-btn/yz-bottom-btn.component';


const COMPONENTS = [
  YzPageComponent,
  YzBottomBtnComponent
];

@NgModule({
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  declarations: [...COMPONENTS],
  entryComponents: [...COMPONENTS],
  imports: [SharedModule],
  exports: [...COMPONENTS]
})
export class PageModule {
}
